import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/common/Loading';

const LoadingContent = ({ loading, children }) => {
  return (
    <>{loading ? <Loading isLoadingAdminPage={true} /> : <>{children}</>}</>
  );
};

LoadingContent.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
};

export default LoadingContent;
